import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { mappingAdListingFeatures, getFeatureAdByKey } from '@app/utils/adFeaturesHelpers';
import { getConfig } from '@app/utils/adItemType';
import { AD_LABEL_TARGET, AD_LABEL_VIEW_MODE, getImageLabelConfig, getTextlabelConfig } from '@app/components/AdLabel/helpers';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
import RibbonAd from '../LabelAd';
import AdThumbnail from './AdThumbnail/AdThumbnail';
import AdBody from './AdBody/AdBody';
import SaveAd from '../SaveAd/SaveAd';
import AdTitle from './AdTitle';
import Styles from './AdItem.module.scss';
import commonStyle from '../commonStyle.module.scss';
const {
  breakpoints
} = theme;
const Item = /*#__PURE__*/styled("div")({
  name: "Item",
  class: "i1jdhhry"
});
const AdItem = ({
  adInfo,
  eventName,
  mappingFeaturesAdData,
  adViewUrl,
  classStr,
  handleClickAdView,
  adItemLocation,
  adParams,
  isEntitlement,
  isUrgentJobAd
}) => {
  const handleImplementClickAdView = e => {
    if (e && handleClickAdView) {
      if (['job_personalize_ads', 'slot_for_sale'].includes(eventName)) {
        handleClickAdView(adInfo, eventName, 'click_ad');
      } else {
        handleClickAdView(adInfo, eventName);
      }
    }
  };
  const adTypeConfig = getConfig(adInfo);
  const adFeatures = mappingAdListingFeatures(adInfo, mappingFeaturesAdData);
  const imageLabelConfig = getImageLabelConfig(adInfo, AD_LABEL_VIEW_MODE.listView, AD_LABEL_TARGET.listgrid);
  const textLabelConfig = getTextlabelConfig(adInfo);
  const ribbonAd = getFeatureAdByKey(adFeatures, 'ribbon');
  const titleAd = getFeatureAdByKey(adFeatures, 'title');
  const priceAd = getFeatureAdByKey(adFeatures, 'price');
  let locationName = '';
  if (adItemLocation === '') {
    locationName = adInfo.region_name;
  } else {
    locationName = adItemLocation === 'ward' ? adInfo.ward_name : adInfo.area_name;
  }
  const saveAdButton = <SaveAd size={16} eventName={eventName} category={adInfo.category} listId={adInfo.list_id} adId={adInfo.ad_id} customClassName={Styles.saveAd} subject={adInfo.subject || ''} index={adInfo.index} />;
  return <Item className={`${Styles.item} ${classStr} ${isEntitlement || isUrgentJobAd ? Styles.itemEntitlement : ''}`}>
      <div className={Styles.wrapperLink}>
        <a className={Styles.wrapperLinkHref} href={adViewUrl}>
          {isEntitlement && <AdTitle title={adInfo.subject || ''} commonStyle={commonStyle} showProtectedLabel />}
          {isUrgentJobAd && <AdTitle isUrgentJobAd={isUrgentJobAd} title={adInfo.subject || ''} commonStyle={commonStyle} />}
          <div className={Styles.wrapperLinkFooter}>
            <AdThumbnail image={adInfo.company_logo || ''} title={adInfo.subject || ''} handleImplementClickAdView={handleImplementClickAdView} numberOfImages={adInfo.number_of_images} adViewUrl={adViewUrl} ribbonAd={ribbonAd && <RibbonAd labelInfo={ribbonAd} commonClass={Styles.ribbonAd} />} isEntitlement={isEntitlement} isUrgentJobAd={isUrgentJobAd} imageLabelConfig={imageLabelConfig} />
            <AdBody saveAdButton={saveAdButton} giftId={adInfo.gift_id || 0} title={adInfo.subject || ''} lastUpdatedTime={adInfo.date} adTypeConfig={adTypeConfig} price={adInfo.price_string && adInfo.price_string} commonStyle={commonStyle} stickyAdType={adInfo.sticky_ad_type} ribbonAd={ribbonAd} titleAd={titleAd} priceAd={priceAd} adParams={adParams} adViewUrl={adViewUrl} handleImplementClickAdView={handleImplementClickAdView} locationName={locationName} giveaway={adInfo.giveaway} isEntitlement={isEntitlement} isUrgentJobAd={isUrgentJobAd} companyName={adInfo?.company_name || ''} textLabelConfig={textLabelConfig} />
          </div>
        </a>
      </div>
    </Item>;
};
AdItem.propTypes = {
  classStr: PropTypes.string,
  adInfo: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array])).isRequired,
  mappingFeaturesAdData: PropTypes.shape({}),
  handleClickAdView: PropTypes.func.isRequired,
  adViewUrl: PropTypes.string.isRequired,
  adItemLocation: PropTypes.string,
  eventName: PropTypes.string,
  adParams: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  isEntitlement: PropTypes.bool,
  isUrgentJobAd: PropTypes.bool
};
AdItem.defaultProps = {
  mappingFeaturesAdData: {},
  adItemLocation: '',
  eventName: '',
  classStr: '',
  adParams: [],
  isEntitlement: false,
  isUrgentJobAd: false
};
export default memo(AdItem);

require("../../../../.linaria-cache/src/components/GridAds/AdItem/AdItem.linaria.module.css");